import {gql} from "@apollo/client";

export const blogPostDetailQuery = gql`
    query blogPostDetailQuery($postId: String) {
        post(id: $postId) {
            id
            title
            body
            coverImages(raw: true)
            youtubeVideo
            videoContent {
                id
                status
                type
                url {
                    url
                }
            }
            created
            modified
            readingTime
            numberOfViews
            status
            topic {
                id
                name
            }
            flaggedByUser
            shareUrl
            author {
                id
                firstName
                lastName
                profilePhoto
                university {
                    id
                    name
                    widgetUrl
                }
                degree {
                    id
                    name
                }
                country {
                    id
                    code
                    name
                }
                mentorFields {
                    primaryFlag {
                        code
                        name
                    }
                    secondaryFlag {
                        code
                        name
                    }
                }
                accountRole
                active
                archived
            }
        }
    }
`;
